module.exports = __webpack_public_path__ + "static/media/bg12.8e3f6423.jpeg";